import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store"; // 导入我们创建的store
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
